import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

import Form from "src/components/Form"
import Heading from "src/components/Heading"
import Modal from "src/components/Modal"

import { camelCaseToHumanize } from "src/utils/string_helpers"

export default function RowDataModal({ row, onClose }) {
  const [filter, setFilter] = useState("")

  useEffect(() => {
    if (!row) {
      setFilter("")
    }
  }, [row])

  const filteredEntries = row?.rowData
    ? Object.entries(row.rowData)
        .filter(([key, value]) => {
          const searchLower = filter.toLowerCase()
          const keyReadable = camelCaseToHumanize(key).toLowerCase()
          const valueStr = String(value ?? "").toLowerCase()
          return (
            keyReadable.includes(searchLower) || valueStr.includes(searchLower)
          )
        })
        .sort(([a], [b]) => a.localeCompare(b))
    : []

  return (
    <Modal isOpen={!!row} onClose={onClose} size="mediumFixed">
      <Modal.Header>
        <Heading.ModalTitle>Row {row?.rowNumber} Data</Heading.ModalTitle>
      </Modal.Header>
      <Modal.Body>
        <div className="px-4">
          <div className="sticky top-0 z-10 bg-white pb-4">
            <Form.IconTextField
              icon={
                <i className="fa-kit fa-search-mdi text-xl text-gray-400" />
              }
              placeholder="Search by field name or value"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            />
          </div>
          <table className="w-full">
            <thead>
              <tr className="border-b">
                <th className="sticky top-14 bg-white py-2 pr-4 text-left font-semibold">
                  Field
                </th>
                <th className="sticky top-14 bg-white py-2 text-left font-semibold">
                  Value
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredEntries.map(([key, value]) => (
                <tr key={key} className="border-b">
                  <td className="min-w-44 py-2 pr-4 text-gray-600">
                    {camelCaseToHumanize(key)}
                  </td>
                  <td className="py-2">{String(value ?? "")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal.Body>
    </Modal>
  )
}

RowDataModal.propTypes = {
  row: PropTypes.shape({
    rowNumber: PropTypes.number,
    rowData: PropTypes.object,
  }),
  onClose: PropTypes.func.isRequired,
}
